/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import NotificationAPI from 'api/NotificationsAPI';

export const handleUpdateTicketNotification = async(ticketName: any, cur_user: any, receiver: string, caseId: string) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketName} Updated`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} updated the ticket: ${ticketName}, `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket'
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};


export const handleShareTicketNotification = async(ticketName: any, cur_user: any, receiver: string, caseId: string) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketName} Shared`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} shared the ticket: ${ticketName}, with you `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket'
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};


export const userJoinedNotification = async(cur_user: any, teamInfo: any, id: string) => {
  const notification = {
    groupId: teamInfo.id,
    userId: id,
    status: 'unread',
    heading: 'Team Member Added',
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} accepted your invite and joined ${teamInfo.name}`,
    type: 'team'
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const inviteUserNotification = async(cur_user: any, teamInfo: any, id: string) => {
  const notification = {
    groupId: teamInfo.id,
    userId: id,
    status: 'unread',
    heading: 'Team Invite',
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} invited you to join the team: ${teamInfo.name}`,
    link: `/join-team/${teamInfo.id}`,
    type: 'invite'
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

// NO LONGER USED

export const handleReviewTicketNotification = async(ticketInfo: any, cur_user: any, receiver: string, caseId: string) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketInfo.ticketName} Review`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} request review of ticket: ${ticketInfo.ticketName}, `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket'
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleApproveTicketNotification = async(ticketInfo: any, cur_user: any, receiver: string, caseId: string) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketInfo.ticketName} Approval`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} approved ticket: ${ticketInfo.ticketName}, `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket'
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};
